export enum FiscalDeviceEventKind {
    DocumentFiscalization = 'DocumentFiscalization',
    DailyReportPrinting = 'DailyReportPrinting',
}

export enum FiscalDeviceEventStatus {
    OK = 'OK',
    Warning = 'Warning',
    Error = 'Error',
    Info = 'Info',
}
